import { DraftState } from '@/types';
import { getConfiguration } from './getConfiguration';

export const getSelectedConfiguration = (draft: DraftState) =>
  getConfiguration(draft, draft.selectedConfigurationId);
